export const iconFontAwesomeMedicalHealthBrain = (
	<i className="fa-solid fa-brain"></i>
);
